<template>
  <div class="liuShuiXianKanBan">
    <h1 style="text-align:center; margin-top: 0vh; line-height: 8vh;">
      {{lineNO}}号{{lineNO === "5" ? "单工位" : "流水线"}}看板
    </h1>
    <table style="width: 100%; border: none;">
      <tr>
        <td v-show="ifShow" align="right" style="width: 33%">
          <span class="timeText">本年</span>
          <span
              ref="numberGrow1"
              :data-time="time"
              class="number-grow"
              :data-value="year">
            0
          </span>
        </td>
        <td align="center" style="width: 33%">
          <span class="timeText">本月</span>
          <span
              ref="numberGrow2"
              :data-time="time"
              class="number-grow"
              :data-value="month">
            0
          </span>
        </td>
        <td align="left" style="width: 33%">
          <span class="timeText">本日</span>
          <span
              ref="numberGrow3"
              :data-time="time"
              class="number-grow"
              :data-value="day">
            0
          </span>
        </td>
      </tr>
    </table>
    <div style="background-color: #2D4054; margin: 1vh 1vh 1vh 1vh;">
      <div style="width: 55%; float: left;">
        <div class="chart1" style="width: 47%; height: 30vh; float: left; margin-left: 6%;"/>
        <div class="chart2" style="width: 47%; height: 30vh; float: left;"/>
        <div class="clear"/>
      </div>
      <div style="width: 45%; float: right;">
        <el-table :data="KGList" height="30vh" size="medium" style="font-size: 2.6vh;">
          <el-table-column prop="factoryNum" label="PC号" :width="fontSize(1.6)"/>
          <el-table-column prop="materialDescription" label="柜型"/>
        </el-table>
      </div>
      <div class="clear"/>
    </div>
    <div style="margin: 1vh;">
      <el-row style="color: #42FFFF; background-color: #253C65;">
        <el-col :span="12">
          <div class="orderTable">当前生产订单</div>
        </el-col>
        <el-col :span="12">
          <div class="orderTable">下台生产订单</div>
        </el-col>
      </el-row>
      <el-row style="background-color: #2A4566;">
        <el-col :span="3"><div class="orderTable">{{nowOrder.factoryNum}}</div></el-col>
        <el-col :span="3"><div class="orderTable"><marquee>{{nowOrder.materialDescription}}</marquee></div></el-col>
        <el-col :span="3"><div class="orderTable">{{nowOrder.materialNo}}</div></el-col>
        <el-col :span="3"><div class="orderTable">{{nowOrder.deliveryDate}}</div></el-col>
        <el-col :span="3"><div class="orderTable">{{nextOrder.factoryNum}}</div></el-col>
        <el-col :span="3"><div class="orderTable"><marquee>{{nextOrder.materialDescription}}</marquee></div></el-col>
        <el-col :span="3"><div class="orderTable">{{nextOrder.materialNo}}</div></el-col>
        <el-col :span="3"><div class="orderTable">{{nextOrder.deliveryDate}}</div></el-col>
      </el-row>
    </div>
    <div style="margin: 0vh;">
      <div class="chart3" style="width: 100%; height: 36vh;"/>
    </div>
  </div>
</template>

<script>
  import "echarts-liquidfill";
  export default {
    data() {
      return {
        ifShow: new Date().toDateString() !== "Thu Sep 10 2020",
        date: new Date().getTime(),
        lineNO: 0,
        time: 2,
        year: 0,
        month: 0,
        day: 100,
        myChart1: null,
        myChart2: null,
        myChart3: null,
        lastDayPlan: 0,
        lastDayDone: 0,
        todayPlan: 0,
        todayDone: 0,
        KGList: [],
        KGHour: [],
        KGValue: [],
        nowOrder: {
          factoryNum: "",
          materialDescription: "",
          materialNo: "",
          deliveryDate: "",
        },
        nextOrder: {
          factoryNum: "",
          materialDescription: "",
          materialNo: "",
          deliveryDate: "",
        },
      };
    },
    mounted() {
      this.lineNO = this.$route.params.lineNO;
      this.getSpAssemblyLineList();
      this.getKGList();
      this.getKGHourSList();
      this.getKGsList();
      this.myChart1 = this.$echarts.init(document.querySelector(".chart1"));
      this.myChart2 = this.$echarts.init(document.querySelector(".chart2"));
      this.myChart3 = this.$echarts.init(document.querySelector(".chart3"));
      setInterval(() => {
        this.getSpAssemblyLineList();
        this.getKGList();
        this.getKGHourSList();
        this.getKGsList();
        this.date = new Date().getTime();
      }, 1000 * 60 * 5);
      setInterval(() => {
        this.KGList.push(this.KGList[0]);
        this.KGList.splice(0, 1);
      }, 4000);
    },
    methods: {
      getSpAssemblyLineList() {
        let params = {
          date: this.date,
          line: this.lineNO,
        };
        this.$http.get("basic","kanban/getSpAssemblyLineList", params).then(res => {
          for(let item of res) {
            if(item.name === "本年开工数量") {
              this.year = (item.bl === null ? 0 : item.bl);
            } else if(item.name === "本月开工数量") {
              this.month = (item.bl === null ? 0 : item.bl);
            } else if(item.name === "本日开工数量") {
              this.day = (item.bl === null ? 0 : item.bl);
            } else if(item.name === "前一天开工计划数量") {
              this.lastDayPlan = (item.bl === null ? 0 : item.bl);
            } else if(item.name === "前一天开工完成数量") {
              this.lastDayDone = (item.bl === null ? 0 : item.bl);
            } else if(item.name === "当天开工计划数量") {
              this.todayPlan = (item.bl === null ? 0 : item.bl);
            } else if(item.name === "当天开工完成数量") {
              this.todayDone = (item.bl === null ? 0 : item.bl);
            }
          }
          this.$nextTick(() => {
            this.setFakeData();
            this.numberGrow(this.$refs.numberGrow1);
            this.numberGrow(this.$refs.numberGrow2);
            this.numberGrow(this.$refs.numberGrow3);
            this.setOptions1();
            this.setOptions2();
          });
        });
      },
      getKGList() {
        let params = {
          date: this.date,
          line: this.lineNO,
        };
        this.$http.get("basic","kanban/getKGList", params).then(res => {
          this.KGList = res;
        });
      },
      getKGHourSList() {
        let params = {
          date: this.date,
          line: this.lineNO,
        };
        this.$http.get("basic","kanban/getKGHourSList", params).then(res => {
          this.KGHour = [];
          this.KGValue = [];
          for(let item of res) {
            this.KGHour.push(item.scanHOUR);
            this.KGValue.push(item.sl);
          }
          this.setFakeData();
          this.$nextTick(() => {
            this.setOptions3();
          });
        });
      },
      getKGsList() {
        let params = {
          date: this.date,
          line: this.lineNO,
        };
        this.$http.get("basic","kanban/getKGsList", params).then(res => {
          if(res.length > 0) {
            this.nowOrder = res[0];
            if(res.length > 1) {
              this.nextOrder = res[1];
            }
          }
        });
      },
      setOptions1() {
        this.myChart1.setOption({
          backgroundColor: "#2D4054",
          title: {
            text: "\n昨天开工数\n\n完成：\n  " + this.lastDayDone + "\n\n计划：\n  " + this.lastDayPlan,
            left: "left",
            textStyle: {
              fontWeight: "normal",
              fontSize: this.fontSize(0.22),
              color: "RGB(255,255,255)",
              lineHeight: this.fontSize(0.27),
            },
          },
          series: [{
            type: "liquidFill",
            radius: "80%",
            data: [this.lastDayDone/this.lastDayPlan, this.lastDayDone/this.lastDayPlan],
            backgroundStyle: {
              borderWidth: this.fontSize(0.05),
              borderColor: "RGB(60,204,214)",
              color: "RGB(63,97,119)",
            },
            label: {
              normal: {
                formatter: this.chartValueFormatter(this.lastDayDone, this.lastDayPlan) + "%",
                textStyle: {
                  fontSize: this.fontSize(0.4),
                  color: "#fff",
                  fontWeight: "bold",
                },
              },
            },
            outline: {
              borderDistance: 0,
              itemStyle: {
                borderWidth: this.fontSize(0.05),
                borderColor: "RGB(68,130,216)",
              },
            },
          }],
        });
      },
      setOptions2() {
        this.myChart2.setOption({
          backgroundColor: "#2D4054",
          title: {
            text: "\n当天开工数\n\n完成：\n  " + this.todayDone + "\n\n计划：\n  " + this.todayPlan,
            textStyle: {
              fontWeight: "normal",
              fontSize: this.fontSize(0.22),
              color: "RGB(255,255,255)",
              lineHeight: this.fontSize(0.27),
            },
          },
          series: [{
            type: "liquidFill",
            radius: "80%",
            data: [this.todayDone/this.todayPlan, this.todayDone/this.todayPlan],
            backgroundStyle: {
              borderWidth: this.fontSize(0.05),
              borderColor: "RGB(60,204,214)",
              color: "RGB(63,97,119)",
            },
            label: {
              normal: {
                formatter: this.chartValueFormatter(this.todayDone, this.todayPlan) + "%",
                textStyle: {
                  fontSize: this.fontSize(0.4),
                  color: "#fff",
                  fontWeight: "bold",
                },
              },
            },
            outline: {
              borderDistance: 0,
              itemStyle: {
                borderWidth: this.fontSize(0.05),
                borderColor: "RGB(68,130,216)",
              },
            },
          }],
        });
      },
      setOptions3() {
        this.myChart3.setOption({
          title:{
            text:" * 流水线小时产出数量",
            textStyle: {
              fontWeight: "normal",
              color: "RGB(255,255,255)",
            },
          },
          xAxis: {
            name: "时间",
            type: "category",
            data: this.KGHour,
            axisLine: {
              lineStyle: {
                // 设置x轴颜色
                color: "#fff",
              },
            },
          },
          yAxis: {
            name: "（台）",
            type: "value",
            axisLine: {
              lineStyle: {
                // 设置y轴颜色
                color: "#fff",
              },
            },
          },
          series: [{
            data: this.KGValue,
            type: "line",
            // 设置折线上圆点大小
            symbolSize:10,
            // 设置拐点为实心圆
            symbol:"circle",
          }],
          color: ["#42FFFF"],
        });
      },
      numberGrow(ele) {
        if (ele.dataset.value < 40) {
          ele.innerHTML = ele.dataset.value;
          return;
        }
        let step = Math.floor((ele.dataset.value * 5) / (ele.dataset.time * 100));
        let current = 0;
        let start = 0;
        let t = setInterval(function() {
          start += step;
          if (start > ele.dataset.value) {
            clearInterval(t);
            start = ele.dataset.value;
            t = null;
          }
          if (current === start) {
            return;
          }
          current = start;
          ele.innerHTML = current.toString().replace(/(\d)(?=(?:\d{3}[+]?)+$)/g, "$1,");
        }, 10);
      },
      chartValueFormatter(value1, value2) {
        if (value1 == 0 || value2 == 0) {
          return 0;
        }
        return Math.round(value1 * 100/value2);
      },
      fontSize(res) {
        let clientWidth = window.innerWidth||document.documentElement.clientWidth||document.body.clientWidth;
        if (!clientWidth) return;
        let fontSize = 100 * (clientWidth / 1920);
        return res*fontSize;
      },
      setFakeData() {
        // 搞点假数据
        if (new Date().toDateString() === "Thu Sep 10 2020") { // 定显示日期
          console.log(this.KGValue);
          this.KGValue = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
          this.todayDone = 0;
          this.todayPlan = 0;
          console.log("当前流水线:" + this.lineNO);
          console.log("当前时间:" + new Date().getHours());
          let hour = new Date().getHours();
          // let hour = 23;
          if (this.lineNO === "1") { // 平均6
            if (hour >= 9) { // 8
              this.KGValue[0] = 7;
              this.todayDone += 7;
            }
            this.todayPlan += 7;
            if (hour >= 10) { // 9
              this.KGValue[1] = 8;
              this.todayDone += 8;
            }
            this.todayPlan += 8;
            if (hour >= 11) { // 10
              this.KGValue[2] = 4;
              this.todayDone += 4;
            }
            this.todayPlan += 4;
            if (hour >= 12) { // 11
              this.KGValue[3] = 8;
              this.todayDone += 8;
            }
            this.todayPlan += 8;
            if (hour >= 13) { // 12
              this.KGValue[4] = 3;
              this.todayDone += 3;
            }
            this.todayPlan += 3;
            if (hour >= 14) { // 13
              this.KGValue[5] = 6;
              this.todayDone += 6;
            }
            this.todayPlan += 6;
            if (hour >= 15) { // 14
              this.KGValue[6] = 5;
              this.todayDone += 5;
            }
            this.todayPlan += 5;
            if (hour >= 16) { // 15
              this.KGValue[7] = 7;
              this.todayDone += 7;
            }
            this.todayPlan += 7;
            if (hour >= 17) { // 16
              this.KGValue[8] = 6;
            }
            this.todayDone += 6;
            if (hour >= 18) { // 17
              this.KGValue[9] = 5;
              this.todayDone += 5;
            }
            this.todayPlan += 5;
            if (hour >= 19) { // 18
              this.KGValue[10] = 1;
              this.todayDone += 1;
            }
            this.todayPlan += 1;
            if (hour >= 20) { // 19
              this.KGValue[11] = 1;
              this.todayDone += 1;
            }
            this.todayPlan += 1;
            if (hour >= 21) { // 20
              this.KGValue[12] = 1;
              this.todayDone += 1;
            }
            this.todayPlan += 1;
            if (hour >= 22) { // 21
              this.KGValue[13] = 0;
            }
          } else if (this.lineNO === "2") { // 平均9
            if (hour >= 9) { // 8
              this.KGValue[0] = 11;
              this.todayDone += 11;
            }
            this.todayPlan += 11;
            if (hour >= 10) { // 9
              this.KGValue[1] = 12;
              this.todayDone += 12;
            }
            this.todayPlan += 12;
            if (hour >= 11) { // 10
              this.KGValue[2] = 7;
              this.todayDone += 7;
            }
            this.todayPlan += 7;
            if (hour >= 12) { // 11
              this.KGValue[3] = 10;
              this.todayDone += 10;
            }
            this.todayPlan += 10;
            if (hour >= 13) { // 12
              this.KGValue[4] = 5;
              this.todayDone += 5;
            }
            this.todayPlan += 5;
            if (hour >= 14) { // 13
              this.KGValue[5] = 8;
              this.todayDone += 8;
            }
            this.todayPlan += 8;
            if (hour >= 15) { // 14
              this.KGValue[6] = 9;
              this.todayDone += 9;
            }
            this.todayPlan += 9;
            if (hour >= 16) { // 15
              this.KGValue[7] = 10;
              this.todayDone += 10;
            }
            this.todayPlan += 10;
            if (hour >= 17) { // 16
              this.KGValue[8] = 8;
              this.todayDone += 8;
            }
            this.todayPlan += 8;
            if (hour >= 18) { // 17
              this.KGValue[9] = 7;
              this.todayDone += 7;
            }
            this.todayPlan += 7;
            if (hour >= 19) { // 18
              this.KGValue[10] = 2;
              this.todayDone += 2;
            }
            this.todayPlan += 2;
            if (hour >= 20) { // 19
              this.KGValue[11] = 2;
              this.todayDone += 2;
            }
            this.todayPlan += 2;
            if (hour >= 21) { // 20
              this.KGValue[12] = 1;
              this.todayDone += 1;
            }
            this.todayPlan += 1;
            if (hour >= 22) { // 21
              this.KGValue[13] = 0;
            }
            console.log("todayPlan:" + this.todayPlan);
          } else if (this.lineNO === "3") { // 平均8
            if (hour >= 9) { // 8
              this.KGValue[0] = 9;
              this.todayDone += 9;
            }
            this.todayPlan += 9;
            if (hour >= 10) { // 9
              this.KGValue[1] = 11;
              this.todayDone += 11;
            }
            this.todayPlan += 11;
            if (hour >= 11) { // 10
              this.KGValue[2] = 6;
              this.todayDone += 6;
            }
            this.todayPlan += 6;
            if (hour >= 12) { // 11
              this.KGValue[3] = 10;
              this.todayDone += 10;
            }
            this.todayPlan += 10;
            if (hour >= 13) { // 12
              this.KGValue[4] = 4;
              this.todayDone += 4;
            }
            this.todayPlan += 4;
            if (hour >= 14) { // 13
              this.KGValue[5] = 8;
              this.todayDone += 8;
            }
            this.todayPlan += 8;
            if (hour >= 15) { // 14
              this.KGValue[6] = 7;
              this.todayDone += 7;
            }
            this.todayPlan += 7;
            if (hour >= 16) { // 15
              this.KGValue[7] = 9;
              this.todayDone += 9;
            }
            this.todayPlan += 9;
            if (hour >= 17) { // 16
              this.KGValue[8] = 8;
              this.todayDone += 8;
            }
            this.todayPlan += 8;
            if (hour >= 18) { // 17
              this.KGValue[9] = 7;
              this.todayDone += 7;
            }
            this.todayPlan += 7;
            if (hour >= 19) { // 18
              this.KGValue[10] = 2;
              this.todayDone += 2;
            }
            this.todayPlan += 2;
            if (hour >= 20) { // 19
              this.KGValue[11] = 1;
              this.todayDone += 1;
            }
            this.todayPlan += 1;
            if (hour >= 21) { // 20
              this.KGValue[12] = 1;
              this.todayDone += 1;
            }
            this.todayPlan += 1;
            if (hour >= 22) { // 21
              this.KGValue[13] = 0;
            }
            console.log("todayPlan:" + this.todayPlan);
          } else if (this.lineNO === "4") { // 平均3
            if (hour >= 9) { // 8
              this.KGValue[0] = 4;
              this.todayDone += 4;
            }
            this.todayPlan += 4;
            if (hour >= 10) { // 9
              this.KGValue[1] = 4;
              this.todayDone += 4;
            }
            this.todayPlan += 4;
            if (hour >= 11) { // 10
              this.KGValue[2] = 1;
              this.todayDone += 1;
            }
            this.todayPlan += 1;
            if (hour >= 12) { // 11
              this.KGValue[3] = 4;
              this.todayDone += 4;
            }
            this.todayPlan += 4;
            if (hour >= 13) { // 12
              this.KGValue[4] = 2;
              this.todayDone += 2;
            }
            this.todayPlan += 2;
            if (hour >= 14) { // 13
              this.KGValue[5] = 4;
              this.todayDone += 4;
            }
            this.todayPlan += 4;
            if (hour >= 15) { // 14
              this.KGValue[6] = 3;
              this.todayDone += 3;
            }
            this.todayPlan += 3;
            if (hour >= 16) { // 15
              this.KGValue[7] = 3;
              this.todayDone += 3;
            }
            this.todayPlan += 3;
            if (hour >= 17) { // 16
              this.KGValue[8] = 3;
              this.todayDone += 3;
            }
            this.todayPlan += 3;
            if (hour >= 18) { // 17
              this.KGValue[9] = 3;
              this.todayDone += 3;
            }
            this.todayPlan += 3;
            if (hour >= 19) { // 18
              this.KGValue[10] = 1;
              this.todayDone += 1;
            }
            this.todayPlan += 1;
            if (hour >= 20) { // 19
              this.KGValue[11] = 1;
              this.todayDone += 1;
            }
            this.todayPlan += 1;
            if (hour >= 21) { // 20
              this.KGValue[12] = 1;
              this.todayDone += 1;
            }
            this.todayPlan += 1;
            if (hour >= 22) { // 21
              this.KGValue[13] = 0;
            }
            console.log("todayPlan:" + this.todayPlan);
          }
        }
      },
    },
  };
</script>

<style lang="scss">
  .liuShuiXianKanBan {
    width: 100%;
    height: 100vh;
    margin: 0 auto;
    background: url("/img/kanban_bg.png") no-repeat;
    background-size: 100% 100%;
    position: relative;
    text-align: center;
    color: #ffffff;
    .el-table, .el-table__expanded-cell, .el-table th, .el-table tr{
      background-color: transparent!important;
      color: #fff;
    }
    ::-webkit-scrollbar, ::-webkit-scrollbar-track {
      background-color: transparent!important;
    }
    .el-table__body tr:hover>td{
      background-color: #263445!important;
    }
    .el-table__body tr.current-row>td{
      background-color: #263445!important;
    }
    .clear{
      clear:both
    }
    .number-grow-warp{
      transform: translateZ(0);
    }
    .number-grow {
      font-family: Arial-BoldMT;
      font-size: 7vh;
      color: #81C3FF;
      letter-spacing: 0.267vh;
      line-height: 7vh;
      margin-left: 3%;
    }
    .timeText {
      font-family: Arial-BoldMT;
      font-size: 4vh;
      line-height: 7vh;
      color: #fff;
    }
    .orderTable {
      height: 5vh;
      line-height: 5vh;
      font-size: 3.6vh;
      text-align:center;
      border: 0.1vh solid #fff;
    }
  }
</style>
